import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-standalone-layout _flexcol _jc-c _ai-c" }
const _hoisted_2 = {
  class: "_tac _px-8 _my-3",
  "data-qa": "payment-processing:Description"
}
const _hoisted_3 = { "format-key": "0" }
const _hoisted_4 = { "format-key": "1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_localize = _resolveComponent("localize")
  const _component_base_button = _resolveComponent("base-button")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, { class: "_flexcol _jc-c _ai-c" }, {
      default: _withCtx(() => [
        _createVNode(_component_base_image, {
          src: "/content/images/site-icon.svg",
          class: "_lh-1 _mb-2 _tc--accent fa-beat-fade",
          width: "54",
          height: "54"
        }),
        _createVNode(_component_base_heading, {
          tag: "h2",
          "data-qa": "payment-processing:Title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.boxTitle), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_localize, { resource: $options.boxDescription }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString($props.maxProcessingTimeMinutes), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_4, _toDisplayString($options.pluralizedMaxProcessingTimeMinutes), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"])
        ]),
        _createVNode(_component_base_button, {
          tag: "a",
          theme: "accent",
          href: $options.projectHomePageUrl,
          "data-qa": "payment-processing:ProjectHomeButton"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.PaymentProcessingBoxActionLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}